import axios from "axios";

let http = axios.create({
  baseURL: "/api",
  headers: {
    "Content-type": "application/json"
  }
});

class MyUploadFilesService {
	upload(file, onUploadProgress) {
		let formData = new FormData();
		formData.append("file", file);
		return http.post("/upload", formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			},
			onUploadProgress
		});
	}
	getFiles() {
		return http.get("/files");
	}
	DownloadFile(fileName) {
		return http.get("/files/"+fileName);
	}
}

export default new MyUploadFilesService();